import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../../Environments/environment";
function DoNotDisturb({ guestId, guestSessionId, guest, setGuest }) {
  const [DNDStatus, setDNDStatus] = useState("not requested");
  const [isLoading, setIsLoading] = useState(false);
  const handleSendRequest = async (status) => {
    const data = {};
    if (DNDStatus === "Accepted" && guest.dndmode) {
      data["dndmode"] = "unrequest";
    } else if (DNDStatus === "Declined" && !guest.dndmode) {
      data["dndmode"] = "requested";
    } else if (DNDStatus === "Accepted" && !guest.dndmode) {
      data["dndmode"] = "requested";
    } else if (DNDStatus === "Declined" && guest.dndmode) {
      data["dndmode"] = "unrequest";
    } else {
      data["dndmode"] = "requested";
    }

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/dndmodeRequest`,
        data,
      );
      setDNDStatus(response.data.result.dndModeRequest.requestStatus);
    } catch (error) {
      console.log(error);
      alert("Request failed. Please try again.", error.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchGuestDndRequest = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/guestApi/${guestSessionId}/dndmodeRequest`,
        );
        if (response.data.result.length > 0) {
          setDNDStatus(response.data.result[0].requestStatus);
        }
      } catch (error) {
        console.error("Error fetching DND status:", error.message);
      }
    };
    const getGuest = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/guestApi/${guestSessionId}/guest`,
        );
        setGuest(response.data.result);
      } catch (error) {
        console.error("Error fetching guest data:", error);
      }
    };

    fetchGuestDndRequest();
    getGuest();
  }, [DNDStatus]);

  return (
    <div className="mx-2 text-white flex flex-row justify-between p-4 border-2 rounded-2xl border-white">
      <p>Do not disturb mode</p>
      <button
        onClick={() => {
          const status =
            DNDStatus === "not requested"
              ? "requested"
              : "DNDStatus" === "Accepted"
                ? "unrequest"
                : "requested";
          handleSendRequest(status);
        }}
        className={`${
          DNDStatus === "not requested" ||
          (DNDStatus === "Accepted" && !guest.dndmode) ||
          (DNDStatus === "Declined" && !guest.dndmode)
            ? "text-green-400"
            : DNDStatus === "requested"
              ? "text-yellow-400"
              : DNDStatus === "Accepted" && guest.dndmode
                ? "text-red-400"
                : "text-gray-400"
        } transition-all duration-300 cursor-pointer font-medium`}
        disabled={DNDStatus === "requested" || isLoading}
      >
        {DNDStatus === "not requested"
          ? "Turn on"
          : DNDStatus === "requested"
            ? "Requested"
            : DNDStatus === "Accepted" && guest.dndmode
              ? "Turn off"
              : DNDStatus === "Accepted" && !guest.dndmode
                ? "Turn on"
                : DNDStatus === "Declined" && !guest.dndmode
                  ? "Turn on"
                  : DNDStatus === "Declined" && guest.dndmode
                    ? "Turn off"
                    : "Requested"}
      </button>
    </div>
  );
}

export default DoNotDisturb;
